export default {
  color: `white`,
  fontWeight: `medium`,
  textDecoration: `none`,
  userSelect: `none`,
  whiteSpace: `pre`,
  transition: `all 250ms ease`,
  p: 0,
  ':visited': {
    color: 'white'
  },
  ':hover': {
    textShadow: `default`
  }
}
